import React, { FC } from 'react'
import NewLayout from './components/NewLayout'

const SiteVisitDisqualified: FC = () => {
  return (
    <NewLayout.Outer>
      <NewLayout.Inner size="xl">
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-6">
          <div className="tw:flex tw:flex-col tw:items-center">
            <p className="tw:text-lg tw:text-center">
              {'Based on your answers, this project may not be the right fit at this time.'}
            </p>
            <p className="tw:text-tertiary-black tw:text-center">
              {
                'Thank you for taking the time to complete the survey. We appreciate your input and hope to collaborate in the future.'
              }
            </p>
          </div>
        </div>
      </NewLayout.Inner>
    </NewLayout.Outer>
  )
}

export default SiteVisitDisqualified
